import { makeApi } from "@zodios/core";
import { z } from "zod";

import { autoDiagDeviceDtoSchema, autoDiagDtoSchema } from "@/types/backoffice/dto/autodiag/auto-diag-dto.ts";
import { autoDiagModulatorDtoSchema } from "@/types/backoffice/dto/autodiag/auto-diag-modulator-dto";

export const backofficeAutoDiagApi = makeApi([
  {
    method: "get",
    path: "/site/:id",
    response: autoDiagDtoSchema,
    alias: "findAutoDiagBySiteId",
  },
  {
    method: "get",
    path: "/site/:id/modulators",
    response: z.array(autoDiagModulatorDtoSchema),
    alias: "findAutoDiagModulatorsBySiteId",
  },
  {
    method: "put",
    path: "/site/:id/test/link/:csLinkId",
    response: autoDiagDeviceDtoSchema,
    alias: "startLinkAutoDiag",
  },
]);
